import NoActivityYetIcon from "../../../img/trade-history/no-activity-yet.svg?react";
import { Button } from "../../../components/general/Button/Button";

import styled from "@emotion/styled";
import { themes } from "../../../styles/theme";
import { NoTradesDisplayContainer } from "./NoTradesDisplayContainer";
import { Spacer } from "../../../components/general/Spacer/Spacer";
import { GlobalStore } from "store/global/GlobalStore";
import { useIsMobile } from "hooks/useDeviceType";
import { buttonCss } from ".";

export const NoActivityYetDisplay: React.FC = () => {
  const theme = GlobalStore.useState(s => s.theme);
  const isMobile = useIsMobile();
  const iconSize = isMobile ? 142 : 100;
  return (
    <NoTradesDisplayContainer>
      <NoActivityYetIcon width={iconSize} height={iconSize} />
      <Spacer height="8px" />
      <NoActivityYetDisplayTitle>You don’t have any activity yet</NoActivityYetDisplayTitle>
      <NoActivityYetDisplayParagraph>
        Your trades will appear here when you start using Bebop.
      </NoActivityYetDisplayParagraph>
      <Button
        buttonType={"primary"}
        navigateTo="/trade"
        shape="square"
        height={40}
        widthExpand={true}
        text="Start Trading"
        textSize={"Medium"}
        buttonCss={buttonCss(theme, isMobile)}
      />
    </NoTradesDisplayContainer>
  );
};

// Sub-components

export const NoActivityYetDisplayTitle = styled.h3`
  margin-top: 0.7rem;
  font-size: 1.2rem;
  color: ${themes.dark.font.primary.default};
  text-align: center;
  font-size: 16px;
  line-height: ${props => props.theme.lineHeights[4]};
  text-align: center;

  @media (max-width: 416px) {
    font-size: 1rem;
  }
`;

export const NoActivityYetDisplayParagraph = styled.p`
  color: ${themes.dark.font.secondary.default};
  width: 100%;
  text-align: center;
  font-size: 14px;

  @media (max-width: 416px) {
    font-size: 0.8rem;
  }
`;
